import React, { useState } from 'react';
// Remove useNavigate since it's causing issues
// import { useNavigate } from 'react-router-dom';
import { useMaintenanceStore } from '../../store/maintenanceStore';
import logo from '../../assets/images/serps-logo.png';
import screwHead from '../../assets/images/screw-head.png';

const MaintenancePage = () => {
  // Remove the navigate constant
  // const navigate = useNavigate();
  const { setMaintenanceMode } = useMaintenanceStore();
  const [clickCount, setClickCount] = useState(0);
  
  const handleSecretToggle = () => {
    const newCount = clickCount + 1;
    setClickCount(newCount);
    
    // After 5 clicks, disable maintenance mode
    if (newCount >= 5) {
      setMaintenanceMode(false);
      console.log('Maintenance mode disabled');
    } else {
      console.log(`Secret area clicked ${newCount} times. Need ${5 - newCount} more clicks.`);
    }
  };
  
  // Common styles for screw heads
  const screwStyle = "absolute w-[25px] h-[25px] opacity-70";
  
  return (
    <div className="flex justify-center items-center h-screen bg-white font-sans text-center relative">
      {/* Top-left screw */}
      <img 
        src={screwHead} 
        alt="" 
        className={`${screwStyle} top-4 left-4`}
      />
      
      {/* Top-right screw */}
      <img 
        src={screwHead} 
        alt="" 
        className={`${screwStyle} top-4 right-4`}
      />
      
      {/* Bottom-right screw */}
      <img 
        src={screwHead} 
        alt="" 
        className={`${screwStyle} bottom-4 right-4`}
      />
      
      {/* Bottom-left screw - clickable but with default cursor */}
      <img 
        src={screwHead} 
        alt="" 
        className={`${screwStyle} bottom-4 left-4`}
        onClick={handleSecretToggle}
        title=""
        style={{ cursor: 'default' }}
      />
      
      <div className="flex flex-col items-center">
        <img 
          src={logo} 
          alt="SERPS" 
          className="max-w-[150px] mb-5"
        />
        
        <div className="text-[#F8761F] text-2xl font-bold">
          We&apos;re under maintenance, please try again after <span className="text-black">10:00 AM EST</span>.
        </div>
        
        <div className="mt-4 text-[#F8761F] text-lg font-bold">
          Thank you for your patience.
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage; 
